/** angular */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
/** end angular */

/** services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** en services */
@Injectable({
  providedIn: 'root',
})
export class DsFileService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get a file through a stream.
   * (optional, the file can be zipped).
   *
   * @param projectId the project id
   * @param filename The file uuid
   * @returns Should return the stream as a blob
   */
  public getFileStream(projectId: number, filename: string): Observable<Blob> {
    this.path = `/v1/projects/${projectId}/files/download`;
    return this.post<Blob>({ body: { filename }, responseType: 'blob' });
  }

  /**
   * No use for now but necessary for BydRhsAbstractService.
   */
  public createNewInstance() {}
}
